import { FMSetPasswordDialog, SessionDuration } from "@fokused-me/web-ui";
import { useCallback } from "react";
import { useSession } from "../state/Session";

export const SetPasswordPage = () => {
   const { startSession } = useSession();

   const handleOnContitnue = useCallback(
      (password: string, duration: SessionDuration) => {
         startSession(password, duration);
      },
      [startSession]
   );

   return <FMSetPasswordDialog onContinue={handleOnContitnue} />;
};
